<template>
  <div>
    <el-select
      :value="value"
      @input="inputtt"
      :placeholder="placeholder"
      clearable
      :multiple="multiple"
      @change="changeHanlder"
      :style="{
        width: width,
      }"
    >
      <el-option
        v-for="item in list"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
        <span style="float: left">{{ item.name }}</span>
        <span
          :style="{ float: 'right', color: $jsTool.getColor('danger') }"
          v-if="item.frozen"
          >已冻结</span
        >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "QshpzyWebOrganzitionSelect",
  props: {
    value: [Object, Array],
    placeholder: {
      type: String,
      default: "请选择门诊部",
    },
    width: {
      type: [Number, String],
      default: "180px",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      list: [],
    };
  },

  mounted() {
    this.list = this.$storageUtil
      .getUserInfo()
      .userOrgList.map((d) => d.organization);
    // 结果按照no正序排列
    this.list.sort((a, b) => a.no - b.no);
  },

  methods: {
    inputtt(e) {
      this.$emit("input", e || null);
    },
    changeHanlder(val) {
      this.$emit("change", val);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/OrganzitionSelect.vue